
function Error(){
    return(
        <>
            <div className="error">
                <h1>OШИБКА: 404</h1>
            </div>
    
        </>
        
    )
}

export default Error;